/* eslint-disable */
export default {
  attachFiles: '파일 첨부',
};

// @key: @#@"attachFiles"@#@ @source: @#@"Attach file"@#@
